<ion-content class="container">
  
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickBackBtn()">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickBackBtn()">360 Review</span> / <span
            [style.color]="buttonColorName">Logs</span></label>
      </div>
    </ion-col> 
  </ion-row>

  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="center-content p-10">
        <div>
          <mat-form-field class="w-90 mat-height40 mat-input-style">
            <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="getessName()">
              <mat-option *ngFor="let item of yearsOfCompany"
                [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyID"
              (selectionChange)="onChangeSurveyLog()">
              <mat-option *ngFor="let item of essNamesList" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ion-col> 
  </ion-row>

  <div class="table-layout">
    <ion-grid class="p-0">
      <div class="tableBox mt-10">
        <ion-row class="p-0">
          <mat-sidenav-container style="width: 100%;height: 100%;">
            <!-- Main Content with AG Grid -->
            <mat-sidenav-content>
              <ag-grid-angular
                style="width: 100%; height: 600px;"
                class="ag-theme-quartz"
                [rowData]="gridData.columnData"
                [columnDefs]="taskDeletedHeaderInfo"
                [gridOptions]="gridOptions"
                [defaultColDef]="defaultColDef"
                (gridReady)="onGridReady($event)"
                (rowClicked)="onRowClicked($event)"
                [pagination]="pagination"
                [paginationPageSize]="paginationPageSize"
                [paginationPageSizeSelector]="paginationPageSizeSelector"
                [detailRowAutoHeight]="detailRowAutoHeight"
                [localeText]="{ noRowsToShow: 'No Data Found' }"
              >
              </ag-grid-angular>
            </mat-sidenav-content>
         
            <!-- Right Side Sidenav -->
            <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
              <!-- HEADER -->
              <div class="details-header">
                <h2>360 Review Logs Details</h2>
                <button mat-icon-button (click)="closeDetails()">
                  <mat-icon class="close-icon">close</mat-icon>
                </button>
              </div>
              <!-- CONTENT -->
              <div class="details-content" *ngIf="selectedRow">
                <mat-card class="detail-card" *ngFor="let col of taskDeletedHeaderInfo">
                  <mat-card-content>
                    <div class="detail-row">
                      <mat-icon class="detail-icon">trending_flat</mat-icon>
                      <div class="detail-text">
                        <span class="detail-label">{{ col.headerName }} </span>
              
                        <span *ngIf="selectedRow[col.field]">
                          <ng-container *ngIf="col.field === 'oldValue' || col.field === 'newValue'; else normalValue">
                            <ng-container *ngIf="isValidDate(selectedRow[col.field]); else normalValue">
                              {{ formatDate(selectedRow[col.field]) }}
                            </ng-container>
                          </ng-container>
                          <ng-template #normalValue>
                            {{ selectedRow[col.field] }}
                          </ng-template>
                        </span>
                        
                        
              
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
              
            </mat-sidenav>
          </mat-sidenav-container>

          <!-- <table class="hover">
            <thead class="bg-gray">
              <tr>
                <th class="fs-14 font_bold cl-black" *ngFor="let item of gridData.columnInfo">
                  <div class="verticle-center icon-style">{{item.label}}
                    <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'">arrow_drop_up</i>
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let item of gridData.columnData;let i=index">
                <td class="fs-16 font_regular">
                  <span>{{item.fieldName}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span >{{item.oldValue}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span>{{item.newValue}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span>{{item.lastModifiedBy}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span>{{item.updatedAt}}</span>
                </td>
                
              </tr>
            </tbody>
          </table> -->
        </ion-row>
      </div>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="display-end">
 
      </ion-col>
      <div class="clear100"></div>
      <div class="clear20"></div>
    </ion-grid>
  </div>
</ion-content>


